var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-transmit',_vm._b({ref:"uploader",staticClass:"v-transmit",class:_vm.disabled ? 'disabled' : '',staticStyle:{"text-align":"center"},on:{"added-files":_vm.addedFiles,"accepted-file":_vm.acceptedFile,"error":_vm.error}},'vue-transmit',_vm.options,false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14174c26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submission/steps/VideoUpload/VideoUploader.vue
// module id = 719
// module chunks = 4 5